export default {
	campus_index({ campus_index }) {
		return campus_index;
	},
};
